import AuthPageContainer from 'components/common/AuthPageContainer';
import { useQueryParams } from 'hooks/useQueryParams';
import { get } from 'lodash';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { AuthAction } from 'redux/actions';
import ROUTES from 'routes/routeConstants';
import { TokenType } from 'types/user';
import { formatMessage } from 'utils/IntlMessages';

import { ResetPasswordFormContent } from './components';
import ResetNewPassword from './components/ResetNewPassword';

const ResetPassword: React.FC = () => {
  const history = useHistory();
  const [user, setUser] = useState('');

  const dispatch = useDispatch();
  const intl = useIntl();
  const queryParams = useQueryParams();

  const token = queryParams.get('token');

  React.useEffect(() => {
    if (!token) {
      // history.replace(ROUTES.TOKEN_EXPIRED);
    } else {
      dispatch(
        AuthAction.verifyToken(token, TokenType.RESET_PASSWORD, (error, data) => {
          if (error) {
            history.replace(ROUTES.TOKEN_EXPIRED);
          } else if (typeof data === 'string') {
            setUser(data);
          } else if (typeof data === 'object') {
            const email = get(data, 'email', '');
            setUser(email);
          }
        }),
      );
    }
  }, [token, dispatch]);

  return (
    <AuthPageContainer
      header={{
        title: formatMessage(intl, 'app.userAuth.forgotPassword'),
        content: formatMessage(intl, 'app.userAuth.forgotPasswordHeaderMessage'),
      }}>
      {token && user && <ResetNewPassword email={user} />}
      {!token && <ResetPasswordFormContent />}
    </AuthPageContainer>
  );
};

export default React.memo(ResetPassword);
